import React from 'react'
import {Flex} from '/app/src/component'
import SVG from 'react-inlinesvg';
import Theme from '/app/src/theme';

import {
  Tooltip
} from 'react-tippy';



export default class Hint extends React.Component {
    render() {
        let {position, tooltip, height, width, ...rest}=this.props
        position = position? position: 'top-right'
        let hintHeight = '20px';
        let hintWidth = '20px';
        if(height){
            hintHeight = height;
        }

        if(width){
            hintWidth = width;
        }
        return (
            <Flex style={this.props.style} cursor='pointer' {...rest}>
            <Tooltip
                title={tooltip}
                html={<div style={{textAlign: 'left', fontSize: '14px'}}>{tooltip}</div>}
                position={position}
                animation='none'
                duration={0}
                hideDelay={0}
                size='big'
                style={{
                    height: hintHeight,
                    width: hintWidth,
                    textAlign: 'left'
                }}
            >
                 <SVG cacheGetRequests={true} style={{fill: Theme.colors.black}} src='/images/Help_S.svg' height='20px' width='20px'/>
            </Tooltip>
            </Flex>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Hint/index.js